import Vue from "vue";
import Vuex from "vuex";
import ui from "./modules/ui";
import members from "./modules/members";
import challenges from "./modules/challenges";
import challengeBuilder from "./modules/challengeBuilder";
import program from "./modules/program";
// [TEAMS FEATURE]
import teams from "./modules/teams";
import authMember from "./modules/authMember";
import general from "./modules/general";
import notices from "./modules/notices";
import registration from "./modules/registration";
import emailTemplates from "./modules/emailTemplates";
import invites from "./modules/invites";
import pages from "./modules/pages";
import challengePackages from "./modules/challengePackages";
import organizations from "./modules/organizations";
import companion from "./modules/companion";
import mobileSupport from "./modules/mobileSupport";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    ui,
    pages,
    members,
    challenges,
    challengeBuilder,
    program,
    // [TEAMS FEATURE]
    teams,
    authMember,
    general,
    notices,
    registration,
    emailTemplates,
    invites,
    challengePackages,
    organizations,
    companion,
    mobileSupport
  },
  getters: {
    viewTitle: state => state.route.meta.viewTitle,
    route: state => state.route
  }
});
